<template>
	<div>
		<div class="row justify-content-center">
			<div class=""><base-button class="w-200" type="primary" round>Моя компания</base-button></div>
			<div class=""><router-link to="/data/staff/myteam"><base-button class="w-200" type="primary" round simple>Моя команда</base-button></router-link></div>
		</div>
		<div class="row preFilterBlk">
			<div class="col-md-3">
				<ReInputSearchDrop 
					name="fio"
					placeholder="ФИО"
					v-model="staff_fio"
					:objApiMethod="{obj:'staff' ,flt:{fio:''}}"
					strApiMethodKey="fio"
					v-on:change="OnFioSearch"
				/>
			</div>
			<div class="col-md-3">
				<ReInputSearchDrop 
					name="contacts"
					placeholder="Контакты"
					strType="staff"
					v-model="staff_contacts"
					:objApiMethod="{obj:'staff' ,flt:{contact:''}}"
					strApiMethodKey="contact"
					v-on:change="OnContactSearch"
				/>
			</div>
			<div class="col-md-3">
				<ReInputSearchDrop 
					name="staff_id"
					placeholder="ID Сотрудника"
					:MinTxtLen="1"
					v-model="staff_id"
					:objApiMethod="{obj:'staff' ,flt:{code:''}}"
					strApiMethodKey="code"
					v-on:change="OnFioSearch"
				/>
			</div>
			<div class="col-md-3"><ReFilterBtn v-model="bShowFilter"/></div>
		</div>
		<div class="row">
			<div class="col-lg-6 mt-2" v-show="bShowFilter">
				<ReFilter :masAllFilterParams="masAllFilterParams" 
				v-model="objGetParams" 
				v-on:filterapply="OnFilterApply"
				name="staffcompany"/>
			</div>
			<div class="col-12" v-if="masStaff.length>0">
				<div class="titleBlk">
					<div class="left_part">
						<div class="avatarBlk"></div>
						<div class="fioBlk"><h3 class="d-inline-block">ФИО</h3><i></i></div>
					</div>
					<div class="right_part">
						<div class="contactsBlk"><h3 class="d-inline-block">Контакты</h3><i></i></div>
						<div class="orgBlk"><h3 class="d-inline-block">Подразделение</h3><i></i></div>
					</div>
				</div>
				<ReSearchCardStaff v-for="objStaff in masStaff" :key="objStaff.id" :objStaff="objStaff"/>
				<Pagination :class="[{'': parseInt(masStaff_total) > 0}, {'d-none': parseInt(masStaff_total) < 1}]"
					:type="'info'" 
					:total="parseInt(masStaff_total)" 
					:perPage="parseInt(10)" 
					:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
					:pClick="pClick">
				</Pagination>				
			</div>
			<div class="col-12" v-else><h3>Ничего не найдено</h3></div>
		</div>
	</div>
</template>

<script>

import {eventEmitter} from "src/plugins/globalComponents.js";
import ReSearchCardStaff from 'src/our_components/ReSearchCardStaff';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import Pagination from 'src/our_components/RePagination';
//import filterConfig from 'src/conf/staffCompany_filterConfig.js';
import ReInputSearchDrop from 'src/our_components/ReInputSearchDrop.vue';

export default {
	name: 'staffCompany-page',
	components:{
		ReSearchCardStaff,
		ReFilter,
		ReFilterBtn,
		Pagination,
		ReInputSearchDrop,
	},
	data() {
		return {
			masStaff: [],
			masStaff_total:0,
			bShowFilter: false,
			objGetParams: {},
			masAllFilterParams: this.currentFilterConfig(),
			staff_fio: {inputText: '', selectedVal:''},
			staff_contacts: {inputText: '', selectedVal:''},
			staff_id: {inputText: '', selectedVal:''},
			strContactTypedText: '',
		};
	},
	methods: {
		currentFilterConfig(){
			this.$GVO.ApiCall('GET_FILTER_COMPANY',{obj:'staff'})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						this.masAllFilterParams = objApi.config;
						eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		getStaff(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));
			}
			//console.log('getStaff',filter);
			this.$GVO.ApiCall('GET',{obj:'staff' ,flt:{...{list:true}, ...filter} })
			.then((objApi) => { 
				this.masStaff_total = 0;
				this.masStaff = [];
				if(objApi.success === true){ //console.log(objApi);
					this.masStaff = objApi.data;
					if(objApi.total!=undefined) { this.masStaff_total=objApi.total; }
				}else{
					this.masStaff = [];
				}
			}).catch((errorObjApi) => {console.error(errorObjApi); this.masStaff = [];});
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
			/*
			this.$nextTick(() => {
				this.$GVO.scrollTop(); 
			});
			*/
		},
		OnFilterApply(){
			//this.objGetParams = data;
			//console.log('OnFilterApply',this.objGetParams);
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getStaff();
		},
		OnFioSearch(data){
			this.objGetParams['code'] = data.selectedVal;
			this.OnFilterApply();
			// console.log('OnFioSearch',this.objGetParams);

		},
		OnContactSearch(data){
			this.objGetParams['code'] = data.selectedVal;
			// this.objGetParams['code'] = data.selectedVal;
			this.OnFilterApply();
		},
		
		ResetDopFilter(){
			this.staff_fio = {inputText: '', selectedVal:''};
			this.staff_contacts = {inputText: '', selectedVal:''};
			this.staff_id = {inputText: '', selectedVal:''};
			delete this.objGetParams['code'];
			this.OnFilterApply();
		}
	},
	created() {
		this.$GVO.LoadCat('cat_position');
		eventEmitter.$on('ResetFilter', this.ResetDopFilter);
		this.getStaff();
	},
	beforeDestroy() {
		// Отписываемся от события
		eventEmitter.$off('ResetFilter', this.ResetDopFilter);
	},
};
</script>
<style scoped>
	
	.titleBlk{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		margin-bottom: 15px;
	}

	.titleBlk h3{margin-bottom: 0px;}

	.titleBlk .avatarBlk{width:215px;}

	.titleBlk .left_part, .titleBlk .right_part{
		width: 100%;
		display: flex;
		flex-flow: row nowrap;
	}
	.titleBlk .right_part{justify-content: space-between;}
	.titleBlk .left_part > *, .titleBlk .right_part > *{display: inline-block; vertical-align: top;}
	.titleBlk .orgBlk{width:285px;}

	.preFilterBlk{align-items: baseline; margin-top:20px;}

	@media (max-width: 1100px){
		.titleBlk{display: none;}
	}
</style>

